import React from 'react'

const ModelsLoader = () => {
  return (
    <div className="flex flex-col ai-card transform translate-y-4 transition-all duration-500 animate-pulse">
      <div className="w-full rounded-xl shadow-md bg-white border border-purple-100/50 overflow-hidden">
        {/* Image placeholder */}
        <div className="w-full aspect-video bg-gradient-to-r from-gray-200 to-gray-300"></div>

        {/* Button placeholders */}
        <div className="absolute top-2 right-2 w-7 h-7 rounded-full bg-gray-300"></div>
        <div className="absolute bottom-2 left-2 w-10 h-5 rounded-full bg-gray-300"></div>
        <div className="absolute bottom-2 right-2 w-10 h-5 rounded-full bg-gray-300"></div>
      </div>

      <div className="mt-4 space-y-3 px-1">
        {/* Title placeholder */}
        <div className="h-5 bg-gray-200 rounded w-3/4"></div>

        {/* Description placeholder */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>

        {/* Buttons placeholder */}
        <div className="flex items-center justify-between w-full pt-1">
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          <div className="h-8 bg-gray-200 rounded w-1/4"></div>
        </div>
      </div>
    </div>
  )
}

export default ModelsLoader
